import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
app.initializers.add('val-ui-linked-discussion-tags', () => {
  const tagsLabel = flarum.reg.get('flarum-tags', 'common/helpers/tagsLabel');
  const isCurrentMobileTag = function (tag) {
    if (window.innerWidth > 767 || !tag || typeof tag.slug !== 'function') {
      return false;
    }
    let current = null;
    try {
      current = m.route.param('tags');
    } catch (err) {}
    if (!current) {
      const match = window.location.pathname.match(/\/t\/([^/?#]+)/);
      if (match) {
        try {
          current = decodeURIComponent(match[1]);
        } catch (err) {
          current = match[1];
        }
      }
    }
    if (!current) return false;
    const plainCurrent = String(current).replace(/^\d+-/, '');
    const slug = String(tag.slug());
    const id = typeof tag.id === 'function' ? String(tag.id()) : '';
    return slug === String(current) || slug === plainCurrent || id === String(current);
  };
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const tags = (this.attrs.discussion.tags() || []).filter(function (tag) {
      const secondary = !!(tag && typeof tag.position === 'function' && tag.position() === null);
      return !secondary && !isCurrentMobileTag(tag);
    });
    if (tags.length) {
      items.add('tags', tagsLabel(tags, {
        link: true
      }), 10);
    }
  });
}, -100);